import router from '../router';
import currentRoute from './currentRoute';

function goToPath(path) {
  if (currentRoute().path !== path) router.push(path);
}

export default goToPath;
